// src/contexts/RoleContext.js

import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext'; // Ensure AuthContext is correctly imported

// Create the RoleContext
const RoleContext = createContext();

// RoleProvider component
export const RoleProvider = ({ children }) => {
  const { user, loading: authLoading } = useAuth(); // Access user from AuthContext
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const determineRole = () => {
      if (authLoading) {
        // Still loading authentication status
        return;
      }

      if (user && user.role === 'admin') {
        setIsAdmin(true);
      } else {
        setIsAdmin(false);
      }

      setLoading(false);
    };

    determineRole();
  }, [user, authLoading]);

  return (
    <RoleContext.Provider value={{ isAdmin, loading }}>
      {children}
    </RoleContext.Provider>
  );
};

// Custom hook to use RoleContext
export const useRole = () => {
  return useContext(RoleContext);
};
